import { BankingSettingsPage } from './banking-settings/BankingSettingsPage'
import { InvoicesPage } from './invoices/InvoicesPage'
import { OutgoingInvoicesPage } from './outgoing-invoices/OutgoingInvoicesPage'
import { RecurringInvoicesPage } from './recurring-invoices/RecurringInvoicesPage'

/**
 * `manager-invoicing` — incoming and outgoing invoices, recurring ones, the bank
 * reconciliation and the PayBySquare QR settings.
 *
 * Ported: banking-settings, recurring-invoices, qr-payment-settings,
 * outgoing-invoices, invoices. The module is complete.
 *
 * **Auto-payment does not pay anybody.** `BLOCKED.md` records that the Tatra Banka
 * PSD2 client is an explicit stub — the scheduler records a failed attempt against
 * every due invoice and leaves them unpaid. The path that works is the SEPA batch on
 * `/invoices`. Every screen here that touches payment has to say which is which
 * (FB-084).
 */
export const managerInvoicingModule = {
  name: 'manager-invoicing',
  routes: [
    {
      path: '/banking-settings',
      page: 'banking-settings',
      guard: { permission: 'banking', franchiseModule: 'invoices.bank_reconciliation' },
      component: BankingSettingsPage,
    },
    {
      path: '/recurring-invoices',
      page: 'recurring-invoices',
      guard: { permission: 'recurring_invoices', franchiseModule: 'invoices.recurring' },
      component: RecurringInvoicesPage,
    },
    {
      path: '/invoices',
      page: 'invoices',
      guard: { permission: 'invoices', franchiseModule: 'invoices.incoming' },
      component: InvoicesPage,
    },
    {
      path: '/outgoing-invoices',
      page: 'outgoing-invoices',
      guard: { permission: 'outgoing_invoices', franchiseModule: 'invoices.outgoing' },
      component: OutgoingInvoicesPage,
    },
  ],
} as const

export {
  BankingSettingsPage,
  InvoicesPage,
  OutgoingInvoicesPage,
  RecurringInvoicesPage,
}
